import { ThreadMessage } from "root/ChatPanel";
import { MessageFromEnum, MessageStatusEnum } from "types";

const TEMP_THREAD_ID = "temp";

const createPlaceholderMessage = (
  content: string,
  from: MessageFromEnum,
  threadId: string | null,
  retryCount?: number,
): ThreadMessage => ({
  id: crypto.randomUUID(),
  from,
  content: content.trim(),
  status: MessageStatusEnum.Processing,
  createdAt: new Date().toISOString(),
  metadata: null,
  threadId: threadId ?? TEMP_THREAD_ID,
  retryCount,
});

export const createUserMessage = (
  content: string,
  threadId: string | null,
  retryCount = 0,
): ThreadMessage =>
  createPlaceholderMessage(content, MessageFromEnum.User, threadId, retryCount);

export const createAssistantMessage = (
  threadId: string | null,
): ThreadMessage =>
  createPlaceholderMessage("", MessageFromEnum.Assistant, threadId);
